var $, localmed;

$ = window.jQuery;

localmed = require('./base');

require('./plugin');

require('./get-target');

require('./try-trigger');

$(document).on('click.tabs.data-api', '[data-toggle="tab"], [data-toggle-tabs] a', function(event) {
  var element;
  element = $(this);
  if (element.filter($.fn.tabs.defaults.notTabSelector).length) {
    return;
  }
  element.closest('ul').tabs();
  return !element.getOrCreatePlugin('tab').activate();
});

$.plugin('tabPane', {
  defaults: {
    activeClass: localmed.defaults.activeClass
  },
  init: function() {
    return this.isActive = false;
  },
  activate: function() {
    if (this.isActive) {
      return false;
    }
    if (!this.element.tryTrigger('tab-pane:activate')) {
      return false;
    }
    this.isActive = true;
    this.element.addClass(this.options.activeClass).trigger('tab-pane:activated');
    return true;
  },
  deactivate: function() {
    if (!this.isActive) {
      return false;
    }
    if (!this.element.tryTrigger('tab-pane:deactivate')) {
      return false;
    }
    this.isActive = false;
    this.element.removeClass(this.options.activeClass).trigger('tab-pane:deactivated');
    return true;
  },
  toggle: (function(_this) {
    return function() {
      if (_this.isActive) {
        return _this.deactivate();
      } else {
        return _this.activate();
      }
    };
  })(this)
});

$.plugin('tab', {
  defaults: {
    activeClass: localmed.defaults.activeClass
  },
  init: function() {
    var ref;
    this.isActive = false;
    this.pane = this.element.getTarget();
    if ((ref = this.pane) != null ? ref.length : void 0) {
      this.pane.on('tab-pane:activate.tab', (function(_this) {
        return function(event) {
          return _this._onPaneActivate(event);
        };
      })(this)).on('tab-pane:deactivate.tab', (function(_this) {
        return function(event) {
          return _this._onPaneDeactivate(event);
        };
      })(this));
      return this.hasPane = true;
    } else {
      return this.hasPane = false;
    }
  },
  activate: function() {
    if (this.isActive || !this.hasPane) {
      return false;
    }
    if (!this.element.tryTrigger('tab:activate')) {
      return false;
    }
    this.isActive = true;
    if (!this._paneEvent) {
      this.pane.tabPane('activate');
    }
    this.element.addClass(this.options.activeClass).trigger('tab:activated');
    return true;
  },
  deactivate: function() {
    if (!(this.isActive && this.hasPane)) {
      return false;
    }
    if (!this.element.tryTrigger('tab:deactivate')) {
      return false;
    }
    this.isActive = false;
    if (!this._paneEvent) {
      this.pane.tabPane('deactivate');
    }
    this.element.removeClass(this.options.activeClass).trigger('tab:deactivated');
    return true;
  },
  toggle: function() {
    if (this.isActive) {
      return this.deactivate();
    } else {
      return this.activate();
    }
  },
  _onPaneActivate: function(event) {
    this._paneEvent = event;
    this.activate();
    return this._paneEvent = null;
  },
  _onPaneDeactivate: function(event) {
    this._paneEvent = event;
    this.deactivate();
    return this._paneEvent = null;
  }
});

$.plugin('tabs', {
  defaults: {
    activeClass: localmed.defaults.activeClass,
    tabSelector: '[data-target], a[href^="#"]',
    notTabSelector: '[data-toggle="dropdown"]'
  },
  init: function() {
    this.tabs = this._setupTabs();
    this._activateFirst();
    this.tabs.on('click.tabs', (function(_this) {
      return function(event) {
        return _this._onTabClick(event);
      };
    })(this));
    return this.element.on('tab:activate.tabs', (function(_this) {
      return function(event) {
        return _this._onTabActivate(event);
      };
    })(this));
  },
  _setupTabs: function() {
    return this.element.find(this.options.tabSelector).not(this.options.notTabSelector).each(function() {
      return $(this).tab();
    });
  },
  _activateFirst: function() {
    var active;
    active = this.element.find("." + this.options.activeClass);
    if (!active.length) {
      active = this.tabs;
    }
    return active.eq(0).tab('activate');
  },
  _onTabClick: function(event) {
    var tab;
    tab = $(event.target).getOrCreatePlugin('tab');
    return !tab.activate();
  },
  _onTabActivate: function(event) {
    return this.tabs.not(event.target).each(function() {
      return $(this).tab('deactivate');
    });
  }
});
